module.exports = __webpack_public_path__ + "img/xp-tb-drive-relevant-players.f89e271.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gamification/xp-tb-drive-relevant-players.png
// module id = dszt
// module chunks = 39 44